import { render } from "./PosLeftbar-V1.vue?vue&type=template&id=036dded8&scoped=true"
import script from "./PosLeftbar-V1.vue?vue&type=script&lang=js"
export * from "./PosLeftbar-V1.vue?vue&type=script&lang=js"

import "./PosLeftbar-V1.vue?vue&type=style&index=0&id=036dded8&scoped=true&lang=css"
import "./PosLeftbar-V1.vue?vue&type=style&index=1&id=036dded8&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036dded8"]])

export default __exports__